import { Helmet } from "react-helmet-async";

import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Stack,
  MenuItem,
  Container,
  Typography,
  CircularProgress,
  Box,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  Button,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import Iconify from "../components/iconify";
import { useNavigate, useSearchParams } from "react-router-dom";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import { get, post, put } from "src/utils/networkUtils";
import RuleTypeRules from "src/components/promotions/RuleTypeRules";
import InboxUserSearch from "src/components/inbox-table/InboxUserSearch";
import UserLevelSelector from "src/components/UserLevelSelector";

const dateFormat = "YYYY-MM-DD HH:mm:ss";
// ----------------------------------------------------------------------
const DEFAULT = {
  title: "",
  transactionName: "",
  startDate: moment().utc().format(dateFormat),
  endDate: moment().add(1, 'week').utc().format(dateFormat),
  hasExpiration: true,
  applyGroupType: 0,
  ruleType: 0,
  rules: null,
  maxRedemptions: 0,
  status: 0,
}
export default function PromotionPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [promotion, setPromotion] = useState([]);
  const [applyGroupTypes, setApplyGroupTypes] = useState([]);
  const [ruleTypes, setRuleTypes] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [searchParams] = useSearchParams();

  // Handler for user level changes in promotions
  const handleUserLevelChange = (userValueLevelId, checked) => {
    setPromotion((prevState) => {
      const currentRules = prevState.rules || {};
      const currentUserLevels = currentRules.userLevels || [];
      let newUserLevels;

      if (checked) {
        // Add the userValueLevelId if it's not already in the array
        newUserLevels = currentUserLevels.includes(userValueLevelId.toString())
          ? currentUserLevels
          : [...currentUserLevels, userValueLevelId.toString()];
      } else {
        // Remove the userValueLevelId from the array
        newUserLevels = currentUserLevels.filter(id => id !== userValueLevelId.toString());
      }

      return {
        ...prevState,
        rules: {
          ...currentRules,
          userLevels: newUserLevels
        }
      };
    });
  };

  useEffect(() => {
    if (searchParams.has("promotion_id")) {
      let promotionId = searchParams.get("promotion_id");
      get(
        `/admin/promotions/${promotionId}`,
      )
        .then(function (response) {
          const promotionData = response.promotion;
          setPromotion(promotionData);

          // Handle existing specific user IDs if they exist in rules
          if (promotionData.rules && promotionData.rules.users && promotionData.rules.users.length > 0) {
            // Use the actual user data provided by the backend
            setSelectedUsers(promotionData.rules.users);
          } else if (promotionData.rules && promotionData.rules.specificUserIds) {
            let userIds;

            // Handle both array and string formats for backward compatibility
            if (Array.isArray(promotionData.rules.specificUserIds)) {
              userIds = promotionData.rules.specificUserIds;
            } else if (typeof promotionData.rules.specificUserIds === 'string') {
              // Convert comma-separated string to array of numbers
              userIds = promotionData.rules.specificUserIds.split(',')
                .filter(id => id.trim())
                .map(id => parseInt(id.trim()));
            } else {
              userIds = [];
            }

            // Fallback: Convert to user objects with placeholder names
            const users = userIds.map(id => ({ id: id, username: `User ${id}` }));
            setSelectedUsers(users);
          }

          setLoading(false);
        });
    } else {
      setPromotion(DEFAULT);
      setSelectedUsers([]);
      setLoading(false);
    }
    get(
      `/admin/promotions/settings`,
    )
      .then(function (response) {
        console.log("settings", response);
        setApplyGroupTypes(response.applyGroupTypes);
        setRuleTypes(response.ruleTypes);
      });
  }, [searchParams]);
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setPromotion((prevState) => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleDateChange = (newValue, fieldName) => {
    setPromotion((prevState) => ({
      ...prevState,
      [fieldName]: moment(newValue).utc().format(dateFormat),
    }));
  };

  const handleRuleTypeChange = (event) => {
    setPromotion((prevState) => ({
      ...prevState,
      ruleType: event.target.value,
    }));
  };

  const handleApplyGroupTypeChange = (event) => {
    setPromotion((prevState) => ({
      ...prevState,
      applyGroupType: event.target.value,
    }));
  };

  const handleStatusChange = (event) => {
    setPromotion((prevState) => ({
      ...prevState,
      status: event.target.value,
    }));
  };

  const handleRuleDataChange = (newRuleData) => {
    // Update the promotion rules with the new rule data
    setPromotion((prevState) => ({
      ...prevState,
      rules: newRuleData,
    }));
  };

  const handleUserIdsChange = (userIds) => {
    // Update the promotion rules with selected user IDs as array of numbers
    setPromotion((prevState) => {
      const currentRules = prevState.rules || {};
      const updatedRules = {
        ...currentRules,
        specificUserIds: userIds // Store as array of numbers directly
      };

      return {
        ...prevState,
        rules: updatedRules,
      };
    });
  };

  const saveHandler = () => {
    setLoading(true);
    if (searchParams.has("promotion_id")) {
      let promotionId = searchParams.get("promotion_id");
      put(`/admin/promotions/${promotionId}`, promotion)
        .then(function (response) {
          setLoading(false);
          navigate("/dashboard/promotions");
        });
    } else {
      post(`/admin/promotions`, promotion)
        .then(function (response) {
          setLoading(false);
          navigate("/dashboard/promotions");
        });
    }
  };

  console.log("promotion", promotion);
  return (
    <>
      <Helmet>
        <title> Promotion </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Promotion - {searchParams.has("promotion_id") ? "Edit" : "Create New"}
          </Typography>
          <Box>
            <Button
              variant="outlined"
              onClick={() => {
                navigate("/dashboard/promotions");
              }}
              startIcon={<Iconify icon="eva:close-fill" />}
              sx={{ mr: 1 }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={() => saveHandler()}
              startIcon={<Iconify icon="eva:save-fill" />}
              sx={{ mr: 1 }}
              disabled={
                loading ||
                (promotion && promotion.title.length < 3) ||
                (promotion && promotion.transactionName.length < 3)
              }
            >
              Save
            </Button>
          </Box>
        </Stack>

        <Card sx={{ minHeight: 600 }}>
          {promotion === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={2} sx={{ p: 3 }}>
              <Grid item xs={8}>
                <TextField
                  name="title"
                  label="Promotion Title"
                  fullWidth
                  value={promotion.title}
                  variant="outlined"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <InputLabel id="status-select-label">Status</InputLabel>
                  <Select
                    labelId="status-label"
                    id="status-select"
                    value={promotion.status}
                    label="Status"
                    onChange={handleStatusChange}
                  >
                    <MenuItem value={0}>Draft</MenuItem>
                    <MenuItem value={1}>Active</MenuItem>
                    <MenuItem value={2}>Inactive</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DateTimePicker
                    label="Start Date"
                    value={moment.utc(promotion.startDate, dateFormat).local()}
                    onChange={(value) => handleDateChange(value, "startDate")}
                    renderInput={(params) => <TextField {...params} fullWidth />}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={promotion.hasExpiration ? 4 : 8}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="hasExpiration"
                      checked={promotion.hasExpiration}
                      onChange={handleChange}
                    />
                  }
                  label="Has Expiration"
                />
              </Grid>
              {promotion.hasExpiration && (
                <Grid item xs={4}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DateTimePicker
                      label="End Date"
                      value={moment.utc(promotion.endDate, dateFormat).local()}
                      onChange={(value) => handleDateChange(value, "endDate")}
                      renderInput={(params) => <TextField {...params} fullWidth />}
                    />
                  </LocalizationProvider>
                </Grid>
              )}
              <Grid item xs={5}>
                <TextField
                  name="transactionName"
                  label="Transaction Name"
                  fullWidth
                  value={promotion.transactionName}
                  variant="outlined"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  name="maxRedemptions"
                  label="Max Redemptions"
                  type="number"
                  fullWidth
                  value={promotion.maxRedemptions}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={5}>
                <FormControl fullWidth>
                  <InputLabel id="apply-group-type-select-label">Apply Group Type</InputLabel>
                  <Select
                    labelId="apply-group-type-label"
                    id="apply-group-type-select"
                    value={promotion.applyGroupType}
                    label="Apply Group Type"
                    onChange={handleApplyGroupTypeChange}
                  >
                    {applyGroupTypes.map((applyGroupType) => (
                      <MenuItem key={applyGroupType.key} value={applyGroupType.key} disabled={applyGroupType.key === 1}>
                        {applyGroupType.value}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              {promotion.applyGroupType === 2 && (
                <Grid item xs={12} sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" gutterBottom sx={{ mb: 2 }}>
                    Select Specific Users
                  </Typography>
                  <InboxUserSearch
                    onUserSelect={handleUserIdsChange}
                    users={selectedUsers}
                  />
                </Grid>
              )}
              {promotion.applyGroupType === 3 && (
                <UserLevelSelector
                  selectedUserLevels={promotion.rules?.userLevels || []}
                  onUserLevelChange={handleUserLevelChange}
                />
              )}
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <InputLabel id="rule-type-select-label">Rule Type</InputLabel>
                  <Select
                    labelId="rule-type-label"
                    id="rule-type-select"
                    value={promotion.ruleType}
                    label="Rule Type"
                    onChange={handleRuleTypeChange}
                  >
                    {ruleTypes.map((ruleType) => (
                      <MenuItem key={ruleType.key} value={ruleType.key} disabled={ruleType.key === 2}>
                        {ruleType.value}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <RuleTypeRules
                  rules={promotion.rules}
                  ruleType={promotion.ruleType}
                  onRuleDataChange={handleRuleDataChange}
                />
              </Grid>
            </Grid>
          )}
        </Card>
      </Container>
    </>
  );
}
